<template>
  <card>
    <div class="row" style="margin-top: 10px;">
      <div class="col-6">
        <h5>Forecast for next five days</h5>
      </div>
      <div class="col-6" style="margin-top: -10px">
        <div data-toggle="buttons" class="btn-group btn-group-toggle float-right">
          <label class="btn btn-sm btn-primary btn-simple">
            <input type="radio"
                   @click="getForecast()"
                   name="options" autocomplete="off">
            Hourly
          </label>
          <label class="btn btn-sm btn-primary btn-simple active">
            <input type="radio"
                   name="options"
                   autocomplete="off"
                   checked>
            Daily
          </label>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 18px">
      <div class="col-12">
        <forecast-table :forecast="getShort(forecast)" :showScroll="false"></forecast-table>
      </div>
    </div>
  </card>
</template>

<script>
  import { getIcon } from "../../plugins/weatherSettings";
  import ForecastWeatherCard from "./ForecastWeatherCard";
  import ForecastTable from "./ForecastTable";
  export default {
    components: {ForecastTable, ForecastWeatherCard},
    props: ['weather', 'forecast', 'isForecast'],
    name: "SmallForecastWeatherCard",
    methods:{
      getFontSizeTemp(k){
        const w = window.innerWidth;
        const size = (w < 600)? k*40 : k*46;
        return {'font-size': size + 'px'};
      },
      getIcons(con, time){
        return getIcon(con, time)
      },
      getForecast(){
        const type = 'forecast';
        this.$emit('switch', type)
      },
      getShort(forecast){
        let temp = JSON.parse(JSON.stringify(forecast));
        temp.list = [];
        let date = new Date().toDateString();
        for (let index in forecast.list){
          let tempDate = new Date(forecast.list[index].dt*1000);
          if (tempDate.toDateString() !== date && tempDate.getHours() >= 12 && tempDate.getHours() < 15) {
            temp.list.push(forecast.list[index]);
            date = tempDate.toDateString();
          }
        }
        if (temp.list.length < 5){
          temp.list.push(forecast.list[forecast.list.length - 1])
        }
        return temp;
      },
    },
    computed:{
      getTime(){
        const res = new Date().toLocaleString().split(' ')[1].split(':');
        return res[0] + ':' + res[1];
      },
    },
  }
</script>

<style scoped>
  .row{
    margin-top: -10px;
  }
  .description{
    float: right;
  }
</style>
